import "./card-header.scss";
const CardHeader = ({ children, title }) => {
  return (
    <div className="card-header">
      <h3>{title}</h3>
      {children}
    </div>
  );
};
export default CardHeader;
